import React from "react";
import MileagePaidWidget from "./widgets/MileagePaidWidget";
import JobLogSummaryWidget from "./widgets/JobLogSummaryWidget";
import ConsumerCountWidget from "./widgets/ConsumerCountWidget";
import AuthUsageWarningWidget from "./widgets/AuthUsageWarningWidget";
import MissingMonthlyReportsWidget from "./widgets/MissingMonthlyReportsWidget";
import InvoiceSummaryWidget from "./widgets/InvoiceSummaryWidget";
import FlatRateUsageWidget from "./widgets/FlatRateUsageWidget";
import LogMismatchWidget from "./widgets/LogMismatchWidget";
import OverdueFollowupsWidget from "./widgets/OverdueFollowupsWidget";
import OutreachTasksWidget from "./widgets/OutreachTasksWidget";

// Import shared widget styles
import "./widgets/widgets.css";

const widgetMap = {
  "mileage-paid": MileagePaidWidget,
  joblog_paid_summary: JobLogSummaryWidget,
  "consumer-count": ConsumerCountWidget,
  "auth-usage-warning": AuthUsageWarningWidget,
  "monthly-report-needed": MissingMonthlyReportsWidget,
  "invoice-summary": InvoiceSummaryWidget,
  "flat-rate-usage": FlatRateUsageWidget,
  "log-mismatch": LogMismatchWidget,
  "overdue-followups": OverdueFollowupsWidget,
  "outreach-tasks": OutreachTasksWidget,
};

const WidgetContainer = ({ widgets, onlyMyData }) => {
  return (
    <div className="row g-4">
      {widgets
        .filter((w) => w.widget_type !== "customize-dashboard-widgets")
        .map((w) => {
          const WidgetComponent = widgetMap[w.widget_type];
          return WidgetComponent ? (
            <div key={w.widget_type} className="col-12 col-xxl-6 mb-3">
              <WidgetComponent onlyMyData={onlyMyData} />
            </div>
          ) : null;
        })}
    </div>
  );
};

export default WidgetContainer;